import React from 'react';
import { lazyGettext } from '@eb/lazy-gettext';
import { ACCOUNT_SETTINGS_URL, PACKAGE_THREE_NAME } from '../../constants/main';

import { Lock } from '@eb/eds-iconography';

export default {
    breadcrumbs: {
        crumbs: [
            {
                path: ACCOUNT_SETTINGS_URL,
                label: lazyGettext('Account Settings'),
            },
            {
                path: '#',
                label: lazyGettext('Change Package'),
            },
        ],
    },
    iconHero: {
        heading: lazyGettext(
            'You have the Event %(package3Label)s package. If you have questions about your account or want to change your package, please contact us.',
            { package3Label: PACKAGE_THREE_NAME },
        ),
        iconType: <Lock />,
        CTA: lazyGettext('Contact Eventbrite'),
        dataAutomation: 'sales-change-plan-contact-us-button',
    },
};
